module.exports = __webpack_public_path__ + "img/goldregen-2020-049.560f8e67.jpg";